import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import Cropper from 'cropperjs';
import track from '../track';
import api from '../api';
import checkPasswordStrength from '../password_strength_checker';
import { clickWithDataMethod } from './ujs';
import createComboboxDatePicker from '../datepicker';
import { subscribeToConversation } from '../cable/conversation-subscription';
import { subscribeToInbox } from '../cable/inbox-subscription';
import { subscribeToPresence } from '../cable/presence-subscription';
import { chatOverlay } from '../components/chat/chat-overlay';
import { chatFullPage } from '../components/chat/chat-fullpage';
import { chatStore } from '../components/chat/chat-store';
import { messageInput } from '../components/chat/message-input';
import { audioPlayer } from '../components/chat/audio-player';
import { trackChatEvent } from '../components/chat/chat-analytics';
import { landingPageBannerStore } from '../components/landing/landing-page-banner';
import { notificationsMenu } from '../components/notifications/notifications-menu';

Alpine.plugin(focus);
Alpine.magic('track', () => track);
Alpine.magic('trackChat', () => trackChatEvent);
Alpine.magic('api', () => api);
Alpine.magic('clickWithDataMethod', () => clickWithDataMethod);
Alpine.magic('focus', () => focus);
Alpine.magic('checkPasswordStrength', () => checkPasswordStrength);
Alpine.magic('Cropper', () => Cropper);
Alpine.magic('createComboboxDatePicker', () => createComboboxDatePicker);
Alpine.magic('cable', () => ({ subscribeToConversation, subscribeToInbox, subscribeToPresence }));

Alpine.store('chat', chatStore);
Alpine.store('openMenu', { id: null });
Alpine.store('landingPageBanner', landingPageBannerStore);

Alpine.data('chatOverlay', chatOverlay);
Alpine.data('chatFullPage', chatFullPage);
Alpine.data('messageInput', messageInput);
Alpine.data('audioPlayer', audioPlayer);
Alpine.data('notificationsMenu', notificationsMenu);

require('packs/webtour.js');

export default Alpine;
